var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTroy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 28,
    fill: "none",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 4.5c-.8 0-1.8.5-2.1 1.3l-4 9.1-1.4-9c-.1-1-.7-1.4-1.6-1.4h-5l4.3 15v1a2.8 2.8 0 0 1-2.6 2.3h-2.8c-.7 0-1.2.5-1.4 1.5l-.6 3.7h4.9c2.5 0 5.5-1.3 7.5-4.9L60 4.5h-5zM6.9 0c1.5 0 2.2.6 2 2l-.5 2.5h3.4L11 8.8H7.6L6.7 14c-.3 1.9 1.5 2.1 2.5 2.1h.5L9 20.8 8 21c-2.6 0-7.4-.7-6.5-6.2l1-6H0l.7-4.2h2.5L3.9 0h3z",
    fill: "#323e48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.1 4.7-.8 5a3.3 3.3 0 0 1 1.8 3c0 1.6-1.3 3-3 3.2l-.8 5h.5c4.5 0 8.2-3.7 8.2-8.3 0-3.7-2.5-6.9-5.9-8zm-3.8 10.9a3.3 3.3 0 0 1 1-6.3l1-5h-.5a8.2 8.2 0 0 0-8.2 8.3c0 3.8 2.5 7 5.8 8l.9-5z",
    fill: "#00adbb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 4.5h2.9c1.4 0 2.2.6 1.9 2l-.3 1.9c1-2.2 3.4-4 5.8-4a3.4 3.4 0 0 1 .6 0l-1 5.4-1-.1a5 5 0 0 0-4.6 2.8c-.3.6-.5 1.3-.7 2.2l-1 6h-5.4l2.8-16.2zm46.3 17a1.7 1.7 0 0 1-.5 1.2 1.6 1.6 0 0 1-1.2.5c-.5 0-1-.1-1.2-.5s-.6-.7-.6-1.2.2-.9.6-1.2.7-.6 1.2-.6.9.2 1.2.6a1.7 1.7 0 0 1 .5 1.2zm-.3 0a1.4 1.4 0 0 1-.4 1 1.4 1.4 0 0 1-1 .5 1.4 1.4 0 0 1-1-.4 1.5 1.5 0 0 1-.5-1.1 1.5 1.5 0 0 1 .4-1 1.4 1.4 0 0 1 1-.5 1.4 1.4 0 0 1 1.1.4 1.4 1.4 0 0 1 .4 1.1zm-.7 1h-.3l-.4-.8H58v.8h-.3v-2h.7a.6.6 0 0 1 .4.2l.2.4c0 .3-.2.5-.5.5l.5.9zm-.3-1.4a.3.3 0 0 0-.1-.2.3.3 0 0 0-.3-.1H58v.6h.3a.4.4 0 0 0 .3 0 .3.3 0 0 0 0-.3z",
    fill: "#323e48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroy);
export default __webpack_public_path__ + "static/media/troy.858e666acac8451d5c77f75de7612948.svg";
export { ForwardRef as ReactComponent };